import { useNavigate } from 'react-router-dom';
import { logout as logoutApi } from '../../../utils/api';
import { useLogout } from '../hooks/useLogout';
import { useAuth } from '../contexts/AuthContext';

function Logout() {
    const navigate = useNavigate();
    const { logout } = useAuth();

    useLogout(
        logoutApi,
        () => {
            // 認証コンテキストの状態をクリア
            logout();
            navigate('/login', { replace: true });
        },
        (err) => {
            console.error('ログアウト失敗:', err);
            // エラー時も認証状態をクリア
            logout();
        }
    );

    return null;
}

export default Logout;
